import { OwnerType } from "types";
import getIsOwnerType from "./isOwnerType";

const ensureOwnerType = (v: unknown): OwnerType | undefined =>
  getIsOwnerType(v) ? v : undefined

export default ensureOwnerType
